module.exports = __webpack_public_path__ + "img/arrow_head_right_p.b19dff4a.svg";